module.exports = __webpack_public_path__ + "img/logo.17f7d4c4.png";